<template>
  <v-row no-gutters align="center" style="gap:8px" class="flex-nowrap">
    <v-col :cols="periodo_preset === null ? 4 : 6">
      <v-autocomplete
        v-model="id_fitofarmaco"
        :items="fitofarmaci_items"
        item-text="dettagli.prodotto"
        item-value="id_fitofarmaco"
        label="Fitofarmaco"
        placeholder="Seleziona un prodotto..."
        outlined
        dense
        clearable
        hide-details
      />
    </v-col>
    <v-col :cols="periodo_preset === null ? 3 : 6">
      <v-select
        v-model="periodo_preset"
        :items="periodi_list"
        item-value="value"
        item-text="label"
        label="Periodo"
        outlined
        dense
        hide-details
      />
    </v-col>
    <template v-if="periodo_preset === null">
      <v-col cols="3">
        <v-menu
          v-model="picker_inizio"
          :close-on-content-click="false"
          offset-y
          min-width="auto"
        >
          <template #activator="{ on }">
            <v-text-field
              v-model="data_inizio"
              label="Dal"
              prepend-inner-icon="mdi-calendar"
              readonly
              v-on="on"
              hide-details
              dense
              outlined
            />
          </template>
          <v-date-picker v-model="data_inizio" @input="picker_inizio = false" />
        </v-menu>
      </v-col>
      <v-col cols="2">
        <v-menu
          v-model="picker_fine"
          :close-on-content-click="false"
          offset-y
          min-width="auto"
        >
          <template #activator="{ on }">
            <v-text-field
              v-model="data_fine"
              label="Al"
              prepend-inner-icon="mdi-calendar"
              readonly
              v-on="on"
              hide-details
              dense
              outlined
            />
          </template>
          <v-date-picker v-model="data_fine" @input="picker_fine = false" :min="data_inizio" />
        </v-menu>
      </v-col>
    </template>
  </v-row>
</template>

<script>
import moment from "moment";

// Parametri della maschera "Trattamenti": prodotto fitofarmaco + periodo.
// Emette via v-model l'oggetto { id_fitofarmaco, ts_inizio, ts_fine } già
// risolto, così il layer (MappaTrattamenti) non deve conoscere preset/date
// picker: riceve solo i parametri risolti.
export default {
  name: "TrattamentiFiltri",
  props: {
    value: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      id_fitofarmaco: this.value.id_fitofarmaco || null,
      periodo_preset: 0,
      data_inizio: null,
      data_fine: null,
      picker_inizio: false,
      picker_fine: false,
      periodi_list: [
        { label: "Ultima settimana", value: 7 },
        { label: "Ultimo mese", value: 30 },
        { label: "Ultimi 3 mesi", value: 90 },
        { label: "Anno corrente", value: 0 },
        { label: "Personalizzato", value: null },
      ],
    };
  },
  computed: {
    fitofarmaci_items() {
      return [...this.$store.getters.get_fitofarmaci].sort((a, b) =>
        (a.dettagli.prodotto || "").localeCompare(b.dettagli.prodotto || "")
      );
    },
    ts_inizio() {
      if (this.periodo_preset !== null) {
        const jan1 = moment().startOf("year");
        if (this.periodo_preset === 0) return jan1.format("X");
        const subtracted = moment().subtract(this.periodo_preset, "days").startOf("day");
        return moment.max(subtracted, jan1).format("X");
      }
      return this.data_inizio ? moment(this.data_inizio).startOf("day").format("X") : null;
    },
    ts_fine() {
      if (this.periodo_preset !== null) {
        return moment().format("X");
      }
      return this.data_fine ? moment(this.data_fine).endOf("day").format("X") : null;
    },
  },
  watch: {
    id_fitofarmaco() { this.emitValue(); },
    ts_inizio() { this.emitValue(); },
    ts_fine() { this.emitValue(); },
  },
  mounted() {
    this.emitValue();
  },
  methods: {
    emitValue() {
      this.$emit("input", {
        id_fitofarmaco: this.id_fitofarmaco,
        ts_inizio: this.ts_inizio,
        ts_fine: this.ts_fine,
      });
    },
  },
};
</script>
